import { escapeCsvCell } from "./csvFileHelpers";
import { formatTimestampForTable } from "./dateDisplay";
import { isPlaceholderEmail } from "./displayEmail";
import { isAnalyzeSentimentEnabled } from "./surveySentiment";

/**
 * Header labels for survey individual-response CSV (fixed cols + one/two per question).
 * @param {Array<{ question_text?: string, question_type?: string, analyze_sentiment?: boolean }>} questions
 * @returns {string[]}
 */
export function surveyIndividualResponsesCsvHeaderLabels(questions) {
  const labels = ["Respondent", "Email", "Responded at"];
  for (const q of Array.isArray(questions) ? questions : []) {
    const text = q?.question_text != null ? String(q.question_text).trim() : "";
    labels.push(text || "Question");
    if (isAnalyzeSentimentEnabled(q)) {
      labels.push(`${text || "Question"} (Sentiment)`);
    }
  }
  return labels;
}

/**
 * @param {Record<string, unknown>} row
 * @param {Array<{ question_type?: string, analyze_sentiment?: boolean }>} questions
 * @returns {string[]}
 */
export function surveyIndividualResponseRowToCsvCells(row, questions) {
  const emailRaw = row?.email != null ? String(row.email).trim() : "";
  const email =
    emailRaw && emailRaw !== "—" && !isPlaceholderEmail(emailRaw) ? emailRaw : "";
  const respondent =
    row?.respondent_display != null && String(row.respondent_display).trim() !== ""
      ? String(row.respondent_display).trim()
      : email;
  const respondedDisplay = formatTimestampForTable(row?.responded_at);
  const cells = [
    respondent === "—" ? "" : respondent,
    email,
    respondedDisplay === "—" ? "" : respondedDisplay,
  ];
  const answers = Array.isArray(row?.answers) ? row.answers : [];
  const qs = Array.isArray(questions) ? questions : [];
  for (let i = 0; i < qs.length; i += 1) {
    const a = answers[i] || {};
    const answer = a.answer != null ? String(a.answer) : "";
    cells.push(answer);
    if (isAnalyzeSentimentEnabled(qs[i])) {
      const sentiment = a.sentiment != null ? String(a.sentiment).trim() : "";
      cells.push(answer ? sentiment : "");
    }
  }
  return cells;
}

/**
 * @param {Record<string, unknown>[]} rows
 * @param {Array<{ question_text?: string, question_type?: string }>} questions
 * @returns {string}
 */
export function buildSurveyIndividualResponsesCsvExportText(rows, questions) {
  const list = Array.isArray(rows) ? rows : [];
  const header = surveyIndividualResponsesCsvHeaderLabels(questions)
    .map(escapeCsvCell)
    .join(",");
  const lines = [
    header,
    ...list.map((row) =>
      surveyIndividualResponseRowToCsvCells(row, questions).map(escapeCsvCell).join(",")
    ),
  ];
  return lines.join("\r\n");
}
